import React, { useState } from "react";
import StreamingVideo from "./StreamingVideo";

const HeroComponent = () => {
  const [error, setError] = useState(false);

  const handleError = () => {
    setError(true);
  };

  return (
    <section
      className="hero-section position-relative overflow-hidden"
      style={{ backgroundColor: "#ffffff" }}
    >
      <div
        className="video-container"
        style={{ position: "relative", width: "100%", paddingBottom: "56.25%" }}
      >
        {error ? (
          <div
            className="bg-danger d-flex align-items-center justify-content-center"
            style={{ height: "100%" }}
          >
            <div className="text-center text-white">
              <h1 className="display-4 fw-bold">Oops!</h1>
              <p className="lead">The video has failed to load.</p>
            </div>
          </div>
        ) : (
          <StreamingVideo
            videoFile="HeroImage_placeholder_v2.mp4"
            onError={handleError}
						autoPlay={true} // Added to ensure smooth autoPlay for this video after update to streamingVideo component
          />
        )}
      </div>
    </section>
  );
};

export default HeroComponent;
